<template lang="pug">
  #CustomerStickersModel.CustomerModel.CustomerModel-stickerModel(
    :class="{ 'CustomerModel-active': showModel }"
  )
    .row.align-items-start.p-3
      .col-10
        h2.mb-0 {{ title }}
      .col-2
        img.rounded-circle.closeIcon(
          v-lazy="iconUrl.IconClose",
          fluid,
          alt="Close Icon",
          @click="closeModel()"
        )
    .content.lineStickerBox
      b-tabs(
        content-class="mt-3"
      )
        b-tab(
          v-for="tab in 3",
          :key="`tab_${tab}`",
          :title="`貼圖 ${tab}`",
          @click="active_tab = tab",
          :active="active_tab === tab"
        )
          .BoxBody
            .BoxBody__Content.position-relative.text-center
              .BoxBody__Content-stickers.mt-4.row(v-for="(stickerIdIndex,index) in lineStickers")
                .stickersBox.col-4(
                  v-for="sticker in stickerIdIndex.stickersOne",
                  v-show="tab === 1"
                )
                  img.stickersBox__img(
                    :package_id="sticker.package_id",
                    :sticker_id="sticker.sticker_id",
                    :src="require(`@/assets/images/lineStickers/11537/${sticker.url}`)",
                    draggable="false",
                    @click="selectSticker(sticker.package_id,sticker.sticker_id)"
                  )
                .stickersBox.col-4(
                  v-for="sticker in stickerIdIndex.stickersTwo",
                  v-show="tab === 2"
                )
                  img.stickersBox__img(
                    v-bind:package_id="sticker.package_id",
                    v-bind:sticker_id="sticker.sticker_id",
                    :src="require(`@/assets/images/lineStickers/11538/${sticker.url}`)",
                    draggable="false",
                    @click="selectSticker(sticker.package_id,sticker.sticker_id)"
                  )
                .stickersBox.col-4(
                  v-for="sticker in stickerIdIndex.stickersThree",
                  v-show="tab === 3"
                )
                  img.stickersBox__img(
                    v-bind:package_id="sticker.package_id",
                    v-bind:sticker_id="sticker.sticker_id",
                    :src="require(`@/assets/images/lineStickers/11539/${sticker.url}`)",
                    draggable="false",
                    @click="selectSticker(sticker.package_id,sticker.sticker_id)"
                  )
</template>

<script>
import IconCloseUrl from '@/assets/images/icon/icon_close.png';

// 貼圖 JSON
import lineStickersJson from '@/helper/LineStickers/lineStickers.json';

export default {
  name: 'StickerModel',
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      iconUrl: {
        IconClose: IconCloseUrl
      },
      showModel: false,
      lineStickers: lineStickersJson,
      active_tab: 1
    };
  },
  mounted() {
    this.$EventBus.$on('openStickerModel', () => {
      this.initHandler();
    });
  },
  methods: {
    initHandler() {
      this.stickerPage = '1';
      this.openModel();
    },
    openModel() {
      this.showModel = true;
    },
    closeModel() {
      this.$emit('closeModelHandler');
      this.showModel = false;
    },
    // 選擇貼圖, 並傳送貼圖
    selectSticker(package_id, sticker_id) {
      this.$emit('postSendApiHandler', {
        type: 'sticker',
        package_id,
        sticker_id
      });
      this.closeModel();
    }
  },
  beforeDestroy() {
    this.$EventBus.$off('openStickerModel');
  }
};
</script>

<style>

</style>
